<template>
  <div>
    <button 
      @click="addToQuote" 
      style="color: green; font-size: 16px;width:100%;padding:8px;cursor:pointer;"
      :disabled="getDisabledW">
    Agregar a cotización
    </button>
  </div>
</template>

<script>
export default {
  props: ['title', 'category', 'subcategory', 'index'],
  data () {
    return {
      disabled: false
    }
  },
  computed: {
    getDisabled () {
      // if (this.title === 'CYMOX 10') {
      //   this.disabled = true
      // }
      // return this.disabled
      return this.$store.getters.getQuotationIndex
    },
    getDisabledW () {
      this.disabled = this.$store.getters.getQuotationIndex.includes(this.title)

      return this.disabled
    }
  },
  methods: {
    addToQuote (product, index) {
      this.disabled = true

      let item = {
        index: this.index,
        title: this.title,
        category: this.category,
        subcategory: this.subcategory,
        disable: this.disabled
      }

      this.$store.dispatch('quotationRequest', item)
    }
  }
};
</script>

<style>
	
</style>